var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['dot', _vm.showContent && 'has-content'],style:(_vm.dotStyle)},[_vm._v(_vm._s(_vm.showContent))])}
var staticRenderFns = []

export { render, staticRenderFns }